import React from 'react';
import { LightBackground } from 'scy/Background';
import { SmallUppercase } from 'scy/text';
import { ThumbnailCarousel } from 'scy/Carousel';
import { uppercase } from 'scy/text/styles.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

const sliderSettings = {
  slidesToShow: 7,
  slidesToScroll: 7,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 6, slidesToScroll: 6 } },
    { breakpoint: 769, settings: { slidesToShow: 5, slidesToScroll: 5 } },
    { breakpoint: 415, settings: { slidesToShow: 5, slidesToScroll: 5 } },
    { breakpoint: 360, settings: { slidesToShow: 4, slidesToScroll: 4 } }
  ]
};

export default function RecommendationsCard({ recommendations = [], onClick }) {
  if (!recommendations.length) return null;

  return (
    <LightBackground tag="section" className={styles.recommendationsCard}>
      <SmallUppercase
        tag="div"
        className={uppercase}
        marginClass={`${margin.top_0} ${margin.bottom_sm}`}
      >
        Don’t Forget to Add
      </SmallUppercase>
      <ThumbnailCarousel
        products={recommendations}
        onClick={onClick}
        sliderSettings={sliderSettings}
      />
    </LightBackground>
  );
}
